<template>
  <div class="text-grey-dark-light language-picker p-3 text-right w-full">
    <a
      :key="locale.code"
      v-for="locale in locales"
      @click="changeLang(locale.code)"
      :class="getSelectClass(locale)"
      class="language-option"
    >
      {{ locale.name }}
    </a>
  </div>
</template>

<script>
import locales from '@/locales/locales'
import formatterService from '@/core/format.service'
import { useCompanyStore } from '@/stores/company'
import localStorageService from '@/core/localstorage.service'
// VeeValidate v4+ handles localization differently
// Locale imports are no longer needed as they're handled automatically

export default {
  setup () {
    const companyStore = useCompanyStore()

    return {
      companyStore
    }
  },

  data () {
    return {
      locales
    }
  },
  computed: {
    currentLang () {
      return locales[this.$i18n.locale]
    },
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    getSelectClass (lang) {
      return this.currentLang.code === lang.code ? 'active' : 'cursor-pointer'
    },
    changeLang (languageCode) {
      formatterService.updateFormatLocale(languageCode)
      this.$i18n.locale = languageCode
      this.$router.replace({
        ...this.baseRouteConfig,
        name: this.$route.name,
        params: { language: languageCode }
      })
      localStorageService.setItem('locale', languageCode)

      // VeeValidate v4+ handles localization automatically
      // No manual localization needed
      this.$emit('languageChanged', { languageCode })
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  font-weight: bold;
}
.language-picker {
  font-size: 18px;

  .language-option {
    &:not(:last-child)::after {
      content: ' | ';
    }
  }
}
</style>
